module.exports = __webpack_public_path__ + "static/woman_set_6adult.dda041f7.svg";